import React from 'react';

import { SciPage } from 'enums';
import { useViewComponent } from 'hooks';

export const NotFoundPage: React.FC = () => {
  const NotFoundView = useViewComponent(SciPage.NotFound);
  return <NotFoundView />;
};
